import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  TextInputComponent,
  TextModes,
} from '../../components/ui/controls/text-input/text-input.component';
import { ListItem } from '../../../../../../libs/Shared/components/model/listItem';
import { LeadsService } from '../../models/leads/leadsService';
import { LogPhoneDialogComponent } from './log-phone-dialog/log-phone-dialog.component';
import { LogEmailDialogComponent } from './log-email-dialog/log-email-dialog.component';
import { UIHelpers } from '../../core/ui-helpers';
import { LeadProgressBarComponent } from './lead-progress-bar/lead-progress-bar.component';
import { ApplicationDialogComponent } from './application-dialog/application-dialog.component';
import { CacheService } from '../../core/storage/cacheService';
import {
  DdlInputComponent,
  DDLModes,
} from '../../components/ui/controls/ddl-input/ddl-input.component';
import { ContactDialogComponent } from '../../components/ui/dialogs/contact-dialog/contact-dialog.component';
import { AssignedUser } from '../../models/users/assignedUser';
import { Person } from '../../models/person/person';
import { BasePage } from '../BasePage';

@Component({
  selector: 'app-lead-page',
  templateUrl: './lead-page.component.html',
  standalone: false,
})
export class LeadPageComponent extends BasePage {
  @ViewChild(LeadProgressBarComponent) progress:
    | LeadProgressBarComponent
    | undefined;
  @ViewChild('states') states: DdlInputComponent | undefined;
  @ViewChild('ddlState') ddlState: DdlInputComponent | undefined = undefined;
  @ViewChild('txtPostalCode') txtPostalCode: TextInputComponent | undefined =
    undefined;

  lead: any | undefined = undefined;

  inputTextModes = TextModes;
  ddlModes = DDLModes;
  addressOptions = CacheService.addressTypesList;

  // for new leads
  contact: any = {};
  business: any = {};
  solution: any = '';

  currentStepIdx: number = 4;

  processingTypeOptions: ListItem[] = [
    new ListItem({ id: 'CreditCard', name: 'Credit Card' }),
    new ListItem({ id: 'ACH', name: 'ACH' }),
  ];

  contactTypeOptions: ListItem[] = [
    new ListItem({ id: 'primary', name: 'Primary' }),
    new ListItem({ id: 'principle', name: 'Principle Owner' }),
    new ListItem({ id: 'pci', name: 'PCI Compliance' }),
    new ListItem({ id: 'accounting', name: 'Accounting' }),
    new ListItem({ id: 'technical', name: 'Technical' }),
  ];

  selectedProcessingType: string | undefined = undefined;
  selectedProcessor: string | undefined = undefined;

  testLead = {
    dba: 'Krispy Kreme Donuts - Clayton',
    legalName: 'Krispy Kreme Store #12345',
    industry: 'Retail food',
    annualRev: '2600000',
    monthlyRev: '223000',
    website: '',
    dbaPhone: '',
    taxID: '',
    businessType: '',
    targetOpenDate: '',
    contacts: [],
    company: {
      franchiseBrand: '',
      dbaOperatingAreas: '',
      primaryBusinessOps: '',
      countryFormed: '',
      yearEstablished: '',
      dbaFax: '',
      phone: '',
    },
    addresses: [
      {
        type: '[legal|mailing:dba]',
        contactName: '',
        contactPhone: '',
        street: '',
        city: '',
        state: '',
        postalCode: '',
        country: '',
      },
    ],
  };
  // testLead = {
  //   contacts: [
  //     new Contact(
  //       {
  //       type: Contact.contactTypes[0],
  //       person: new Person({
  //         firstName: "Krusty",
  //         lastName: "Klown",
  //         emailAddress: "krusty@krispy.com",
  //         phoneNumber: "3145551212",
  //         faxNumber: "3141234567",
  //       }),
  //     })
  //   ],
  //   business: {
  //     dba: "",
  //     legalName: "",
  //     industry: "",
  //     annualRev: ,
  //     monthlyRev:
  //   },
  //   solution: "The dream synthesizer did not seem to exist: a wavetable synthesizer with a truly high-quality sound, visual and creative workflow-oriented interface to make creating and altering sounds fun instead of tedious, and the ability to “go deep” when desired - to create / import / edit / morph wavetables, and manipulate these on playback in real-time.",
  //   notes: "",
  // }

  populateStates(countryCode: string) {
    this.states?.lookupOptions(countryCode);
  }

  constructor(
    public logPhoneDialog: MatDialog,
    public logEmailDialog: MatDialog,
    public addOwnerDialog: MatDialog,
    public applicationDialog: MatDialog,
    public contactDialog: MatDialog,
    public router: Router,
    public leadService: LeadsService,
    public uiHelpers: UIHelpers,
    private cache: CacheService,
  ) {
    super();
    this.lead = this.testLead;
  }

  override ngOnInit() {
    super.ngOnInit();
    this.selectBookmark('solutionContainer');
  }

  ngAfterViewInit() {
    this.progress?.selectStep(this.currentStepIdx);
  }

  ddlCountry_change() {
    if (this.ddlState) {
      this.ddlState.lookupOptions(this.lead.country);
    }

    if (this.txtPostalCode) {
      if (this.lead.country == 'CA') {
        this.txtPostalCode.type = this.inputTextModes.PostalCodeCAN;
      } else {
        this.txtPostalCode.type = this.inputTextModes.PostalCodeUS;
      }
    }
  }

  selectBookmark(selector: string) {
    let tabs = document.getElementsByClassName('content selected');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove('selected');
    }

    let tabContents = document.getElementsByClassName('tabContent selected');
    for (var i = 0; i < tabContents.length; i++) {
      tabContents[i].classList.remove('selected');
    }

    let selectedTab = document.getElementById('tab_' + selector);

    selectedTab?.children[0].classList.add('selected');

    let selectedTabContent = document.getElementById(selector);

    selectedTabContent?.classList.add('selected');
  }

  btnEditContact_click(c: AssignedUser) {
    let ref = this.contactDialog.open(ContactDialogComponent, {
      width: '500px',
      disableClose: false,
      data: {
        contact: c,
        readonly: false,
      },
    });

    this.router.events.subscribe(() => {
      ref.close();
    });

    ref.afterClosed().subscribe((contact) => {});
  }

  btnAddContact_click() {
    let ref = this.contactDialog.open(ContactDialogComponent, {
      width: '500px',
      disableClose: false,
      data: {},
    });

    this.router.events.subscribe(() => {
      ref.close();
    });

    ref.afterClosed().subscribe((contact) => {});
  }

  btnCreateLead_click() {
    // create lead
    this.lead = {
      business: this.business,
      contact: this.contact,
      solution: this.solution,
    };

    this.currentStepIdx = 0;

    this.progress?.selectStep(this.currentStepIdx);

    // TESTING
    this.lead = this.testLead;

    this.selectBookmark('businessContainer');

    UIHelpers.scrollToTop();
  }

  btnLogPhone_click() {
    let ref = this.logPhoneDialog.open(LogPhoneDialogComponent, {
      width: '500px',
      disableClose: false,
      data: {
        leadId: '',
      },
    });

    this.router.events.subscribe(() => {
      ref.close();
    });

    ref.afterClosed().subscribe((refresh) => {
      if (refresh) {
        // reload history
      }
    });
  }

  btnLogEmail_click() {
    let ref = this.logPhoneDialog.open(LogEmailDialogComponent, {
      width: '500px',
      disableClose: false,
      data: {
        leadId: '',
      },
    });

    this.router.events.subscribe(() => {
      ref.close();
    });

    ref.afterClosed().subscribe((refresh) => {
      if (refresh) {
        // reload history
      }
    });
  }

  btnCreateApplication_click() {
    let ref = this.logPhoneDialog.open(ApplicationDialogComponent, {
      width: '800px',
      maxHeight: '80vh',
      position: {
        top: '100px',
      },
      disableClose: true,
      data: {
        leadId: '',
        type: this.selectedProcessingType,
      },
    });

    this.router.events.subscribe(() => {
      ref.close();
    });

    ref.afterClosed().subscribe((refresh) => {
      if (refresh) {
        // reload history
      }
    });
  }
}
